// extracted by mini-css-extract-plugin
export var infoRow = "_ra-2";
export var labelContainer = "_ra-0";
export var rightInfo = "_ra-1";